<template>
  <div class="mw-2026-cta-icon-panels-container" :class="active.panelClass">
    <div class="mw-announcement-active container max-w-4xl">
      <div class="container">
        <div class="flex">
          <div class="mw-announcement-content-container">
            <div class="mw-announcement-content" ref="content">
              <h2>{{ active.title }}</h2>
              <div>
                <div
                  class="html-content"
                  v-html="active.content"
                  style="-webkit-box-orient: vertical;"
                ></div>
                <a
                  v-if="active.url && active.url.length"
                  :href="active.url"
                  class="button mt-4"
                >
                  {{
                    active.label && active.label.length
                      ? active.label
                      : "LEARN MORE"
                  }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="home-speaker-controls">
          <button
            type="button"
            class="slick-prev slick-arrow fmi-icon fmi-icon-arrow-left"
            :aria-disabled="activeIndex === 0"
            @click="prevActive()"
          ></button><button
            type="button"
            class="slick-next slick-arrow fmi-icon fmi-icon-arrow-right"
            :aria-disabled="activeIndex === initialData.length - 1"
            @click="nextActive()"
          ></button>
        </div>
      </div>
      <div class="mw-announcement-image-container">
        <div class="mw-announcement-image" :style="active.image ? { backgroundImage: 'url(' + active.image + ')' } : {}"></div>
        <div class="pagination-circle-container">
          <a
            @click.prevent="updateActive(item, $event)"
            class="pagination-circle"
            v-for="(item, index) in initialData"
            :key="index"
            :class="{ active: index === activeIndex }"
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialData: { type: Array },
  },
  data() {
    return {
      active: this.initialData[0],
      activeIndex: 0,
    };
  },
  methods: {
    animateToActive(newItem, newIndex) {
      const el = this.$refs.content;
      if (!el) {
        this.active = newItem;
        this.activeIndex = newIndex;
        return;
      }

      // 1. Lock at current height, no transition yet.
      const fromHeight = el.offsetHeight;
      el.style.transition = "none";
      el.style.height = fromHeight + "px";
      el.style.overflow = "hidden";

      // 2. Force reflow so the locked height is committed by the browser.
      void el.offsetHeight;

      // 3. Swap content.
      this.active = newItem;
      this.activeIndex = newIndex;

      this.$nextTick(() => {
        // 4. scrollHeight is unreliable when shrinking — it returns
        //    max(clientHeight, contentHeight), so temporarily release to
        //    auto to read the true natural height of the new content.
        el.style.height = "auto";
        const toHeight = el.offsetHeight;

        // 5. Restore the locked height and force reflow so the browser
        //    commits fromHeight as the animation start point.
        el.style.height = fromHeight + "px";
        void el.offsetHeight;

        // 6. Animate to the true target height.
        el.style.transition = "height 0.4s ease";
        el.style.height = toHeight + "px";

        // 7. Release back to auto once the animation finishes.
        const cleanup = () => {
          el.style.height = "auto";
          el.style.overflow = "";
          el.style.transition = "";
          el.removeEventListener("transitionend", cleanup);
        };
        el.addEventListener("transitionend", cleanup);
      });
    },

    nextActive() {
      const nextIndex =
        this.activeIndex === this.initialData.length - 1
          ? 0
          : this.activeIndex + 1;
      this.animateToActive(this.initialData[nextIndex], nextIndex);
    },

    prevActive() {
      const nextIndex =
        this.activeIndex === 0
          ? this.initialData.length - 1
          : this.activeIndex - 1;
      this.animateToActive(this.initialData[nextIndex], nextIndex);
    },

    updateActive(item, e) {
      if (e && e.target) {
        const container = e.target.closest(".pagination-circle-container");
        if (container) {
          const activeButton = container.querySelector("a.pagination-circle.active");
          if (activeButton) activeButton.classList.remove("active");
        }
        e.target.classList.add("active");
      }
      const newIndex = this.initialData.indexOf(item);
      this.animateToActive(item, newIndex);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/js/vue-components/cta-icon-panels/cta-icon-panels.vue